import { TorneoListaBuenaFe, TorneoListaBuenaFeJSON } from '../TorneoListaBuenaFe/TorneoListaBuenaFe';
export interface TorneoListaBuenaFeOficialAuxiliarJSON {
  tlbfoa_id: string;
  tlbfoa_tlbfid: string;
  tlbfoa_apellido: string;
  tlbfoa_nombre: string;
  tlbfoa_documento_numero: string;
  tlbfoa_orden: string;
  torneoListaBuenaFe: TorneoListaBuenaFeJSON | null;
}

export class TorneoListaBuenaFeOficialAuxiliar {
  protected constructor(
    private id: string,
    private tlbfid: string,
    private apellido: string,
    private nombre: string,
    private documentoNumero: string,
    private orden: string,
    private torneoListaBuenaFe: TorneoListaBuenaFe | null
  ) {}

  static createFrom(
    id: string,
    tlbfid: string,
    apellido: string,
    nombre: string,
    documentoNumero: string,
    orden: string,
    torneoListaBuenaFe: TorneoListaBuenaFe | null
  ) {
    return new this(id, tlbfid, apellido, nombre, documentoNumero, orden, torneoListaBuenaFe);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TorneoListaBuenaFeOficialAuxiliar) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TorneoListaBuenaFeOficialAuxiliarJSON) {
    return TorneoListaBuenaFeOficialAuxiliar.createFrom(
      entity.tlbfoa_id,
      entity.tlbfoa_tlbfid,
      entity.tlbfoa_apellido,
      entity.tlbfoa_nombre,
      entity.tlbfoa_documento_numero,
      entity.tlbfoa_orden,
      entity.torneoListaBuenaFe ? TorneoListaBuenaFe.fromJSON(entity.torneoListaBuenaFe) : null
    );
  }

  toJSON(): TorneoListaBuenaFeOficialAuxiliarJSON {
    return {
      tlbfoa_id: this.getId(),
      tlbfoa_tlbfid: this.getTlbfid(),
      tlbfoa_apellido: this.getApellido(),
      tlbfoa_nombre: this.getNombre(),
      tlbfoa_documento_numero: this.getDocumentoNumero(),
      tlbfoa_orden: this.getOrden(),
      torneoListaBuenaFe: null,
    };
  }

  getId(): string {
    return this.id;
  }

  getTlbfid(): string {
    return this.tlbfid;
  }

  getApellido(): string {
    return this.apellido;
  }

  getNombre(): string {
    return this.nombre;
  }

  getDocumentoNumero(): string {
    return this.documentoNumero;
  }

  getOrden(): string {
    return this.orden;
  }

  getTorneoListaBuenaFe(): TorneoListaBuenaFe | null {
    return this.torneoListaBuenaFe;
  }
}
